import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import React from "react";

const discoveryEligibleCoachCountQueryKey = [
  "discoveryEligibleCoachCount",
] as const;

export const getDiscoveryEligibleCoachCount = createServerFn({
  method: "GET",
}).handler(async (): Promise<number> => {
  const [
    { getDBWithInit },
    { getDiscoveryEligibleCoachWhereClause },
    { coaches },
    { count },
  ] = await Promise.all([
    import("~/lib/db"),
    import("~/lib/server/discovery-coach-filters"),
    import("~/../drizzle/schema"),
    import("drizzle-orm"),
  ]);

  const db = await getDBWithInit();
  const whereClause = await getDiscoveryEligibleCoachWhereClause();
  const [result] = await db
    .select({ count: count() })
    .from(coaches)
    .where(whereClause);

  return result.count;
});

export const Route = createFileRoute("/embed/discovery-eligible-coaches/")({
  loader: async ({ context }): Promise<Record<string, never>> => {
    await context.queryClient.ensureQueryData({
      queryKey: discoveryEligibleCoachCountQueryKey,
      queryFn: () => getDiscoveryEligibleCoachCount(),
    });
    return {};
  },
  component: DiscoveryEligibleCoachCountPage,
});

function DiscoveryEligibleCoachCountPage(): React.JSX.Element {
  const { data: coachCount } = useQuery({
    queryKey: discoveryEligibleCoachCountQueryKey,
    queryFn: () => getDiscoveryEligibleCoachCount(),
  });

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-white">
      <div className="font-heading text-[min(40vw,40vh)] tabular-nums">
        {coachCount}
      </div>
    </div>
  );
}
